import mainMenu from './main-menu'
import secondaryMenu from './secondary-menu'
import specialMenu from './special-menu'
import explanations from './explanations'
import animations from './animations'
import hotspots from './hotspots.html'

export default {
	mainMenu,
	secondaryMenu,
	specialMenu,
	explanations,
	animations,
	hotspots
}
